import { Button, Checkbox, Form, Input, Select, Upload } from 'antd';
import { useEffect, useState } from 'react';
import SearchAddress from '../../Utils/SearchAddress';
import TextArea from 'antd/es/input/TextArea';
import { PlusOutlined } from '@ant-design/icons';
import { useAppData } from '../../../hooks/useAppData';
import { useOfferReducer } from '../../../hooks/useOfferReducer';

const CreateOffer1 = ({ page }) => {
    const { data: datas } = useAppData();
    const { formData, updateMultipleFields, nextStep, currentDeal } = useOfferReducer();

    const [form] = Form.useForm();
    const [imgList, setImgList] = useState(formData.images || []);

    const filters = datas?.filters
        .filter(filter => filter.active === 1)
        .map(filter => ({ value: filter.id, label: filter.name }));

    useEffect(() => {
        if (currentDeal) {
            const mergedData = { ...formData, ...currentDeal };
            updateMultipleFields(mergedData);
            setImgList(mergedData.images || []);
            // Utiliser setTimeout pour s'assurer que le formulaire est prêt
            setTimeout(() => {
                form.setFieldsValue(mergedData);
            }, 100);
        } else {
            // Réinitialiser le formulaire pour une nouvelle offre
            form.resetFields();
            setImgList([]);
        }
    }, [currentDeal, updateMultipleFields]);

    const handleAddressChange = (fieldName, place) => {
        updateMultipleFields({ [fieldName]: place });
        form.setFieldsValue({
            [fieldName]: place
        });
    };

    const onValuesChange = (changedValues, allValues) => {
        updateMultipleFields(allValues);
    };

    const onFinish = () => {
        console.log('Final Form Data:', formData);
        nextStep();
    };

    const onFileChange = ({ fileList }) => {
        setImgList(fileList);
        updateMultipleFields({ images: fileList });
    };

    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLessThan3MB = file.size / 1024 / 1024 < 3;

        if (!isJpgOrPng) {
            form.setFields([
                {
                    name: 'images',
                    errors: ['Le fichier doit être au format JPG ou PNG.'],
                },
            ]);
            return Upload.LIST_IGNORE;
        }

        if (!isLessThan3MB) {
            form.setFields([
                {
                    name: 'images',
                    errors: ['La taille du fichier ne doit pas dépasser 3MB.'],
                },
            ]);
            return Upload.LIST_IGNORE;
        }

        return false;
    };

    return (
        <div className='flex flex-col w-full h-full'>
            <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
                onValuesChange={onValuesChange}
                className='space-y-6'
                style={{ width: '100%' }}
            >

                {/* Checkbox for isPassNeeded */}
                <Form.Item name="isPassNeeded" valuePropName="checked" initialValue={false}>
                    <Checkbox
                        checked={formData.isPassNeeded || false}
                        onChange={(e) =>
                            updateMultipleFields({ isPassNeeded: e.target.checked })
                        }
                    >
                        Faut-il montrer le pass Behandy?
                    </Checkbox>
                </Form.Item>

                <Form.Item
                    label="Type(s) de promo"
                    name="tags"
                    rules={[
                        {
                            required: true,
                            message: 'Veuillez choisir un type!'
                        }
                    ]}
                >
                    <Select
                        mode="multiple"
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Choississez au moins un type"
                        options={filters}
                        size="large"
                        dropdownStyle={{ zIndex: "100000" }}
                    />
                </Form.Item>

                <Form.Item
                    label="Titre de l'offre"
                    name="offer"
                    rules={[
                        {
                            required: true,
                            message: 'Entrez votre titre!',
                        },
                        {
                            max: 140,
                            message: 'Le titre ne peut pas dépasser 140 caractères!',
                        }
                    ]}
                >
                    <Input size="large" maxLength={140} />
                </Form.Item>

                <Form.Item
                    label="Localisation"
                    name="localisation"
                >
                    <SearchAddress onAddressChange={handleAddressChange} address={formData.localisation ? formData.localisation : null} fieldName="localisation" />
                </Form.Item>

                <Form.Item
                    label="Description"
                    name="description"
                    hasFeedback
                    rules={[
                        {
                            max: 1000,
                            message: 'La description ne peut pas dépasser 1000 caractères!',
                        }
                    ]}
                >
                    <TextArea size='large' maxLength={1000} showCount />
                </Form.Item>

                <Form.Item
                    label="Tag(s) de promo"
                    name="tagsDescription"
                    rules={[
                        {
                            required: true,
                            message: 'Veuillez choisir un tag!'
                        }
                    ]}
                >
                    <Select
                        mode="tags"
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Choississez au moins un tag"
                        size="large"
                        dropdownStyle={{ zIndex: "100000" }}
                    />
                </Form.Item>

                <Form.Item
                    label="Ajouter une image"
                    name="images"
                >
                    <Upload
                        beforeUpload={beforeUpload}
                        onChange={onFileChange}
                        multiple={false}
                        fileList={imgList}
                        listType="picture-card"
                        maxCount={1}
                        onPreview={async (file) => {
                            let src = file.url;
                            if (!src) {
                                src = await new Promise((resolve) => {
                                    const reader = new FileReader();
                                    reader.readAsDataURL(file.originFileObj);
                                    reader.onload = () => resolve(reader.result);
                                });
                            }
                            const image = new Image();
                            image.src = src;
                            const imgWindow = window.open(src);
                            imgWindow.document.write(image.outerHTML);
                        }}
                    >
                        {imgList.length < 1 && (
                            <div>
                                <PlusOutlined />
                                <div style={{ marginTop: 8 }}>Upload</div>
                            </div>
                        )}
                    </Upload>
                </Form.Item>

                <div className="flex justify-end space-x-4 pt-6">
                    <Button type="primary" htmlType="submit" size="large">
                        Suivant
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default CreateOffer1;
